import type { ReactNode } from 'react';
import { Stepper, type StepperStep } from '../../components/ui/Stepper';
import { Logo } from '../../app/components/Logo';
import type { OnboardingStepName } from './useOnboardingState';

const STEPS: StepperStep[] = [
  { key: 'cnpj', label: 'CNPJ' },
  { key: 'providers', label: 'Provedores' },
  { key: 'demo', label: 'Cotação demo' },
  { key: 'api-key', label: 'Chave de API' },
];

interface OnboardingLayoutProps {
  step: OnboardingStepName;
  title: string;
  description?: string;
  children: ReactNode;
}

/** Shared shell for the 5 onboarding screens — header with the step progress, consistent title/description block. */
export function OnboardingLayout({ step, title, description, children }: OnboardingLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background font-sans text-foreground">
      <header className="border-b border-border px-4 py-4 sm:px-6">
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-4">
          <Logo />
          <Stepper steps={STEPS} currentKey={step} />
        </div>
      </header>

      <main className="flex flex-1 justify-center px-4 py-10 sm:px-6">
        <div className="flex w-full max-w-3xl flex-col gap-6">
          <div className="flex flex-col gap-2">
            <h1 className="text-2xl font-medium text-foreground sm:text-3xl">{title}</h1>
            {description ? <p className="text-sm leading-relaxed text-muted-foreground">{description}</p> : null}
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
